'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const Downshift = require('downshift');
const clsx = require('clsx');
const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_forms_FloatingMenu_FloatingMenu = require('../FloatingMenu/FloatingMenu.cjs.js');
const components_forms_Input_Input = require('../Input/Input.cjs.js');
const utils_formatAriaAttrKeys = require('../../../utils/formatAriaAttrKeys.cjs.js');
const utils_omit = require('../../../utils/omit.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const Downshift__default = /*#__PURE__*/_interopDefault(Downshift);

const root = "_root_o0qgb_1";
const buttonWrap = "_button-wrap_o0qgb_5";
const button = "_button_o0qgb_5";
const buttonText = "_button-text_o0qgb_17";
const placeholder = "_placeholder_o0qgb_28";
const styles = {
	root: root,
	buttonWrap: buttonWrap,
	button: button,
	buttonText: buttonText,
	placeholder: placeholder
};

const isDisabled = (props) => {
  return props.isDisabled || props.items.length === 0;
};
const buildAriaLabel = ({ label, value, placeholder }) => {
  return [value, label, !value && placeholder].filter(Boolean).join(", ");
};
function Dropdown(_a) {
  var { size = "medium", getLabelForItem = (item) => item.label, renderFloatingMenu = (props2) => react.jsx(components_forms_FloatingMenu_FloatingMenu.FloatingMenu, Object.assign({}, props2)), menuAriaLabel = "List of items" } = _a, otherProps = tslib_es6.__rest(_a, ["size", "getLabelForItem", "renderFloatingMenu", "menuAriaLabel"]);
  const props = Object.assign({
    size,
    getLabelForItem,
    renderFloatingMenu,
    menuAriaLabel
  }, otherProps);
  const parentRef = React.useRef(null);
  const itemToString = (item) => {
    return item ? props.getLabelForItem(item) : "";
  };
  const onChangeNoNull = (selection) => {
    var _a2;
    if (selection) {
      (_a2 = props.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(props, selection);
    }
  };
  const onSelectNoNull = (selection) => {
    var _a2;
    if (selection) {
      (_a2 = props.onSelect) === null || _a2 === void 0 ? void 0 : _a2.call(props, selection);
    }
  };
  const stateReducer = (_, changes) => {
    switch (changes.type) {
      case Downshift__default.default.stateChangeTypes.keyDownEscape:
        return {
          isOpen: false
        };
      default:
        return changes;
    }
  };
  const renderButtonForItem = props.renderButtonForItem || props.getLabelForItem;
  return react.jsx(Downshift__default.default, { initialSelectedItem: props.initialSelectedItem, inputId: props.inputId, itemCount: props.items.length, itemToString, onChange: onChangeNoNull, onSelect: onSelectNoNull, stateReducer, selectedItem: props.selectedItem }, ({ clearSelection, closeMenu, getInputProps, getItemProps, getMenuProps, getRootProps, highlightedIndex, isOpen, openMenu, selectItem, selectedItem, setHighlightedIndex }) => {
    const hasSelectedItem = !!selectedItem;
    const renderIcon = () => typeof props.renderIcon === "function" ? props.renderIcon(selectedItem) : void 0;
    const rootProps = utils_omit.omit(getRootProps(), ["aria-labelledby"]);
    const onBlur = (e) => {
      if (props.onBlur) {
        const meta = {
          didBlurWithin: parentRef.current ? parentRef.current.contains(e.relatedTarget) : false,
          closeMenu
        };
        props.onBlur(e, meta);
      } else {
        closeMenu();
      }
    };
    const propsNoOnChangeOrOnClick = tslib_es6.__rest(props, ["onChange", "onClick"]);
    return react.jsx(
      "div",
      Object.assign({ "aria-label": props.menuAriaLabel, "aria-labelledby": props.inputId, className: styles.root }, rootProps, { onBlur, ref: parentRef, "data-zds": true }),
      react.jsx(
        "div",
        { className: styles.buttonWrap, "data-disabled": isDisabled(props), "data-zds": true },
        react.jsx(components_forms_Input_Input.Input, Object.assign({ onClick: () => {
          if (isOpen === true) {
            closeMenu();
          } else if (!isDisabled(props)) {
            openMenu();
          }
          if (props.onClick)
            props.onClick();
        } }, propsNoOnChangeOrOnClick, utils_formatAriaAttrKeys.camelCaseAriaAttrs(getInputProps()), { canClickIconAfter: false, id: props.inputId, isDisabled: isDisabled(props), renderIconAfter: () => react.jsx(components_display_Icon_Icon.Icon, { name: "arrowDropdown", size: size === "compact" ? 20 : 24 }), renderIconBefore: renderIcon }), (inputProps) => (
          // Intentionally `button` and not `Button` since it looks
          // and behaves differently.
          react.jsx("button", {
            // `Downshift` requires this attribute to work properly, so
            // there's an a11y balance to perform here. This is spread as
            // an object since the `eslint-disable-next-line` comment didn't
            // work for JSX props.
            // eslint-disable-next-line jsx-a11y/role-supports-aria-props
            "aria-activedescendant": inputProps["aria-activedescendant"],
            "aria-invalid": inputProps["aria-invalid"],
            "aria-controls": inputProps["aria-controls"],
            "aria-expanded": isOpen ? "true" : "false",
            "aria-haspopup": "true",
            "aria-label": buildAriaLabel({
              label: inputProps["aria-label"] || "",
              placeholder: props.placeholder,
              value: hasSelectedItem ? props.getLabelForItem(selectedItem) : void 0
            }),
            className: styles.button,
            // TODO: remove the extra [class] specifier in Dropdown.module.scss
            // once this has been refactored to css modules.
            css: inputProps.css,
            disabled: inputProps.disabled,
            id: inputProps.id,
            onBlur,
            onFocus: props.onFocus,
            onKeyDown: inputProps.onKeyDown,
            type: "button",
            "data-zds": true
          }, hasSelectedItem ? react.jsx("span", { className: styles.buttonText, "data-zds": true, "data-size": size }, renderButtonForItem(selectedItem)) : react.jsx("span", { className: clsx.clsx(styles.buttonText, styles.placeholder), "data-zds": true, "data-size": size }, props.placeholder))
        ))
      ),
      isOpen && props.renderFloatingMenu({
        "aria-label": props.menuAriaLabel,
        clearSelection,
        closeMenu,
        items: props.items,
        highlightedIndex,
        getKeyForItem: props.getKeyForItem,
        getLabelForItem: props.getLabelForItem,
        getItemProps,
        getMenuProps,
        getInputProps,
        renderIcon: props.renderIcon,
        selectItem,
        selectedItem,
        setHighlightedIndex
      })
    );
  });
}

exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.cjs.js.map
